// components/Equipment/JobCards/JobCardDetails.js

import React, { useState, useEffect } from 'react';
import { Container, Button, Spinner, Card, Row, Col } from 'react-bootstrap';
import { firestore } from '../../utils/firebase';
import { getAuth } from 'firebase/auth';
import { useParams, useNavigate } from 'react-router-dom';

const JobCardDetails = () => {
    const { id } = useParams();  // this is jobCardNumber (MB-JC-xxxx)
    const [jobCard, setJobCard] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        fetchJobCard();
    }, []);

    const fetchJobCard = async () => {
        setLoading(true);
        const auth = getAuth();
        const currentUser = auth.currentUser;
        if (!currentUser) return;

        const userSnapshot = await firestore.collection('users').doc(currentUser.uid).get();
        const company = userSnapshot.data().company;

        // ✅ fetch by jobCardNumber as document ID
        const docRef = firestore.collection('companies').doc(company).collection('JobCards').doc(id);
        const docSnap = await docRef.get();

        if (docSnap.exists) {
            setJobCard(docSnap.data());
        }

        setLoading(false);
    };

    if (loading) {
        return (
            <div className="loading-spinner-container">
                <Spinner animation="border" role="status" variant="success" className="loading-spinner">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        );
    }

    if (!jobCard) {
        return (
            <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '70vh' }}>
                <h3>Job Card not found.</h3>
            </Container>
        );
    }

    return (
        <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '70vh' }}>
            <div style={{ width: '100%', maxWidth: '600px' }}>
                <h1 className="mb-4">Job Card Details</h1>

                <Card className="mb-4">
                    <Card.Body>
                        <Row className="mb-3">
                            <Col><strong>Job Card Number:</strong></Col>
                            <Col>{jobCard.jobCardNumber}</Col>
                        </Row>
                        <Row className="mb-3">
                            <Col><strong>Equipment Number:</strong></Col>
                            <Col>{jobCard.equipmentNumber}</Col>
                        </Row>
                        <Row className="mb-3">
                            <Col><strong>Planned Date:</strong></Col>
                            <Col>{jobCard.plannedDate ? new Date(jobCard.plannedDate.seconds * 1000).toLocaleDateString() : ''}</Col>
                        </Row>
                        <Row className="mb-3">
                            <Col><strong>Priority:</strong></Col>
                            <Col>{jobCard.priority}</Col>
                        </Row>
                        <Row className="mb-3">
                            <Col><strong>Status:</strong></Col>
                            <Col>{jobCard.status}</Col>
                        </Row>
                        <Row className="mb-3">
                            <Col><strong>Assigned To:</strong></Col>
                            <Col>{jobCard.assignedEmployeeName}</Col>
                        </Row>
                        <Row className="mb-3">
                            <Col><strong>Details:</strong></Col>
                            <Col>{jobCard.description}</Col>
                        </Row>
                    </Card.Body>
                </Card>

                {jobCard.status === 'Open' && (
                    <Button
                        variant="success"
                        className="me-3"
                        onClick={() => navigate('/log-maintenance-record', { state: { jobCardId: id } })}
                    >
                        Log Maintenance
                    </Button>
                )}

                <Button
                    variant="outline-success"
                    onClick={() => navigate('/view-job-cards')}
                >
                    Back to Job Cards
                </Button>
            </div>
        </Container>
    );
};

export default JobCardDetails;
